import { Row, Typography, neutral } from 'enable-ui';

import type { SelectMetricLabelProps } from '../core/type';

export const SelectMetricLabel: React.FC<SelectMetricLabelProps> = ({ title, description }) => {
  return (
    <Row
      direction="column"
      style={{
        alignItems: 'initial',
        padding: '10px 0',
      }}
    >
      <Typography
        style={{
          color: '#222222',
          fontSize: 18,
          lineHeight: '26px',
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          style={{
            marginTop: 2,
            color: '#808080',
            fontSize: 16,
            lineHeight: '22px',
          }}
          color={neutral['neutral-7']}
        >
          {description}
        </Typography>
      )}
    </Row>
  );
};
